import * as api from '@/api'

const state = {
  recommendShopList: [],
  recommendShopTotal: 0,
  filterParams: {
    followUpStatus: [],
    visitTimeGreaterThanDays: null,
    visitTimeLessThanDays: null,
  },
  pageNo: 1,
  pageSize: 20,
  loading: false,
  hasMore: true,
}

const MAX_RECOMMEND_SHOPS = 50

const mutations = {
  updateRecommendShopList(state, { list, total, append }) {
    if (append) {
      state.recommendShopList = [...state.recommendShopList, ...list]
    } else {
      state.recommendShopList = list
    }
    state.recommendShopTotal = total
    state.hasMore =
      state.recommendShopList.length < total && state.recommendShopList.length < MAX_RECOMMEND_SHOPS
  },
  updateFilterParams(state, params) {
    state.filterParams = { ...state.filterParams, ...params }
  },
  resetFilterParams(state) {
    state.filterParams = {
      followUpStatus: [],
      visitTimeGreaterThanDays: null,
      visitTimeLessThanDays: null,
    }
  },
  updatePageNo(state, val) {
    state.pageNo = val
  },
  updateLoading(state, val) {
    state.loading = val
  },
  resetRecommendState(state) {
    state.recommendShopList = []
    state.recommendShopTotal = 0
    state.pageNo = 1
    state.hasMore = true
  },
}

const actions = {
  async fetchRecommendShopList({ commit, state }, { append = false, bdUsername } = {}) {
    commit('updateLoading', true)
    const params = {
      pageNo: state.pageNo,
      pageSize: state.pageSize,
    }
    // 筛选参数
    if (state.filterParams.followUpStatus && state.filterParams.followUpStatus.length) {
      params.followUpStatus = state.filterParams.followUpStatus.map(Number)
    }
    if (state.filterParams.visitTimeGreaterThanDays !== null) {
      params.visitTimeGreaterThanDays = state.filterParams.visitTimeGreaterThanDays
    }
    if (state.filterParams.visitTimeLessThanDays !== null) {
      params.visitTimeLessThanDays = state.filterParams.visitTimeLessThanDays
    }
    // BDM查看下属BD
    if (bdUsername) {
      params.bdUsername = bdUsername
    }
    try {
      const result = await api.getRecommendShop(params)
      if (result) {
        commit('updateRecommendShopList', {
          list: result.list || [],
          total: result.total || 0,
          append,
        })
      }
    } catch (e) {
      console.error('fetchRecommendShopList error:', e)
    } finally {
      commit('updateLoading', false)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
